import { render } from "./KodAkaun.vue?vue&type=template&id=95dccc50"
import script from "./KodAkaun.vue?vue&type=script&lang=js"
export * from "./KodAkaun.vue?vue&type=script&lang=js"

import "./KodAkaun.vue?vue&type=style&index=0&id=95dccc50&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__